// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"7912a4a5","453":"badaaee9","507":"a24166c9","541":"6f14e1eb","974":"6f0b1fdb"}[chunkId] + ".chunk.js";
};